import { Component, OnInit, Injector, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { RegisterUserService } from 'src/app/services/registerUser/register-user.service';
import {
  CommonFunctionService,
  UserMerchantData,
} from './../../services/Common/common-function.service';
declare var $: any;

import { MenuService } from '../../core/menu/menu.service';
import { SettingsService } from '../../core/settings/settings.service';
import { AlertComponent } from 'ngx-bootstrap/alert';
import { TransactionService } from 'src/app/services/transaction/transaction.service';
import { Store } from '@ngrx/store';
import {
  selectPermissions,
  selectReserveFund,
} from 'src/app/store/selectors/auth.selectors';
import { getUserPermissions } from 'src/app/store/action/auth.actions';
import { filter, take } from 'rxjs';
import { SessionTimeoutService } from 'src/app/services/session-timeout.service';
const _clone = (d) => JSON.parse(JSON.stringify(d));
@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent implements OnInit, OnDestroy {
  reserveFund$ = this.store.select(selectReserveFund);
  Usertype: any;
  paoutpermissionsvale = 0;
  newoption: boolean = false;
  permissions$ = this.store.select(selectPermissions);
  currency: any;
  PosSetuUphideshow: boolean = false;
  prepaidcard: boolean = false;
  ReserveFund: boolean = false;
  PaygsetUphideshow: boolean = true;
  payoutgideshow: boolean = false;
  rows = [];
  resellerno: any;
  MerchantKeyId: any;
  router: Router;
  sbclickEvent = 'click.sidebar-toggle';
  $doc: any = null;
  whitelableurl: any;
  resellerurl: any;
  resellercontent: any;
  hidebutton: boolean = true;
  constructor(
    public transactionservice: TransactionService,
    private store: Store<any>,
    public settings: SettingsService,
    public injector: Injector,
    public registerUserService: RegisterUserService,
    private commonfunction: CommonFunctionService,
    private sessionTimeoutService: SessionTimeoutService
  ) {}

  ngOnInit() {
    this.sessionTimeoutService.startSessionTimeout();
    this.portalSetup();
    this.GetReserve();
    this.resellerurl = localStorage.getItem('ResellerUrl');
    this.whitelableurl = localStorage.getItem('Whitelabelurl');
    if (this.resellerurl == this.whitelableurl) {
      this.hidebutton = false;
      //    this.PosSetuUphideshow=false
    } else {
      this.hidebutton = true;
      //    this.PosSetuUphideshow=true
    }
    this.router = this.injector.get(Router);

    this.router.events.subscribe((val) => {
      window.scrollTo(0, 0);
      this.settings.setLayoutSetting('asideToggled', false);
    });
    this.anyClickClose();
  }

  anyClickClose() {
    this.$doc = $(document).on(this.sbclickEvent, (e) => {
      if (!$(e.target).parents('.aside-container').length) {
        this.settings.setLayoutSetting('asideToggled', false);
      }
    });
  }

  ngOnDestroy() {
    this.sessionTimeoutService.stopSessionTimeout();

    if (this.$doc) this.$doc.off(this.sbclickEvent);
  }
  navigateToLogin() {
    localStorage.removeItem('VirtualPOSToken'); 
    localStorage.removeItem('logodetails');
    localStorage.removeItem('logoimagepath');
    localStorage.removeItem('Merchantinfoes');
    localStorage.removeItem('Status');
    localStorage.removeItem("WhitelabelContent");
    localStorage.removeItem("ResellerEmail");
    localStorage.removeItem("ResellerPhoneNumber");
    localStorage.removeItem("ResellerName");
    this.router.navigate(['/login']);
  }

  toggleSubmenuClick(event) {
    event.preventDefault();

    if (
      !this.isSidebarCollapsed() &&
      !this.isSidebarCollapsedText() &&
      !this.isEnabledHover()
    ) {
      let ul = $(event.currentTarget.nextElementSibling);

      // hide other submenus
      let parentNav = ul.parents('.sidebar-subnav');
      $('.sidebar-subnav').each((idx, el) => {
        let $el = $(el);
        // if element is not a parent or self ul
        if (el !== parentNav[0] && el !== ul[0]) {
          this.closeMenu($el);
        }
      });

      // abort if not UL to process
      if (!ul.length) {
        return;
      }

      // any child menu should start closed
      ul.find('.sidebar-subnav').each((idx, el) => {
        this.closeMenu($(el));
      });

      // toggle UL height
      const ulHeight = ul.css('height');
      if (ulHeight === 'auto' || parseInt(ulHeight, 10)) {
        this.closeMenu(ul);
      } else {
        // expand menu
        ul.on('transitionend', () => {
          ul.css('height', 'auto').off('transitionend');
        }).css('height', ul[0].scrollHeight);
        // add class to manage animation
        ul.addClass('opening');
      }
    }
  }

  // Close menu collapsing height
  closeMenu(elem) {
    elem.css('height', elem[0].scrollHeight); // set height
    elem.css('height', 0); // and move to zero to collapse
    elem.removeClass('opening');
  }

  toggleSubmenuHover(event) {
    let self = this;
    if (
      this.isSidebarCollapsed() ||
      this.isSidebarCollapsedText() ||
      this.isEnabledHover()
    ) {
      event.preventDefault();

      // this.removeFloatingNav();

      let ul = $(event.currentTarget.nextElementSibling);
      let anchor = $(event.currentTarget);

      if (!ul.length) {
        return; // if not submenu return
      }

      let $aside = $('.aside-container');
      let $asideInner = $aside.children('.aside-inner'); // for top offset calculation
      let $sidebar = $asideInner.children('.sidebar');
      let mar =
        parseInt($asideInner.css('padding-top'), 0) +
        parseInt($aside.css('padding-top'), 0);
      let itemTop = anchor.parent().position().top + mar - $sidebar.scrollTop();

      let floatingNav = ul.clone().appendTo($aside);
      let vwHeight = document.body.clientHeight;

      // let itemTop = anchor.position().top || anchor.offset().top;

      floatingNav.addClass('nav-floating');

      // each item has ~40px height
      // multiply to force space for at least N items
      var safeOffsetValue = 40 * 5;
      var navHeight = floatingNav.outerHeight(true) + 2; // 2px border
      var safeOffset =
        navHeight < safeOffsetValue ? navHeight : safeOffsetValue;

      var displacement = 25; // displacement in px from bottom

      // if not enough space to show N items, use then calculated 'safeOffset'
      var menuTop =
        vwHeight - itemTop > safeOffset
          ? itemTop
          : vwHeight - safeOffset - displacement;

      floatingNav
        .removeClass('opening') // necesary for demo if switched between normal//collapsed mode
        .css({
          position: this.settings.getLayoutSetting('isFixed')
            ? 'fixed'
            : 'absolute',
          top: menuTop,
          bottom:
            floatingNav.outerHeight(true) + menuTop > vwHeight
              ? displacement + 'px'
              : 'auto',
        });

      floatingNav
        .on('mouseleave', () => {
          floatingNav.remove();
        })
        .find('a')
        .on('click', function (e) {
          e.preventDefault(); // prevents page reload on click
          // get the exact route path to navigate
          let routeTo = $(this).attr('route');
          if (routeTo) self.router.navigate([routeTo]);
        });

      this.listenForExternalClicks();
    }
  }

  listenForExternalClicks() {
    let $doc = $(document).on('click.sidebar', (e) => {
      if (!$(e.target).parents('.aside-container').length) {
        //this.removeFloatingNav();
        $doc.off('click.sidebar');
      }
    });
  }

  // removeFloatingNav() {
  //     $('.nav-floating').remove();
  // }

  isSidebarCollapsed() {
    return this.settings.getLayoutSetting('isCollapsed');
  }
  isSidebarCollapsedText() {
    return this.settings.getLayoutSetting('isCollapsedText');
  }
  isEnabledHover() {
    return this.settings.getLayoutSetting('asideHover');
  }

  getUserPermissions() {
    const merchantdata: UserMerchantData =
      this.commonfunction.getUserMerchantData();
    this.currency = this.commonfunction.GetCurrencysymbol();
    //let appName='Merchant';
    this.store.dispatch(
      getUserPermissions({ userId: merchantdata.UserId, appName: 'Merchant' })
    );
    this.permissions$.subscribe((permissions: any[] | null) => {
      if (permissions) {
        for (var i in permissions) {
          if (
            permissions[i].UserPermission == 'PayOut' &&
            this.currency != '$' &&
            this.paoutpermissionsvale == 1
          ) {
            var type = permissions[i].Type;
            if (type == 'R' || type == 'RW' || type == 'RWD') {
              this.payoutgideshow = true;
            } else {
              this.payoutgideshow = false;
            }
          }
          if (permissions[i].UserPermission == 'New') {
            var type = permissions[i].Type;
            if (type == 'RW' || type == 'RWD') {
              this.newoption = true;
            } else {
              this.newoption = false;
            }
          }
          if (permissions[i].UserPermission == 'PaymentLedger') {
            var type = permissions[i].Type;
            if (type == 'R' || type == 'RW' || type == 'RWD') {
              this.newoption = true;
            } else {
              this.newoption = false;
            }
            break;
          }
        }
      }
    });

    // this.transactionservice.GetuserRoleBasedPermissions(merchantdata.UserId, "Merchant").subscribe(result => {

    //     if (result != null) {
    //         for (var i in result) {
    //             if (result[i].UserPermission == 'PayOut' && this.currency != "$" && this.paoutpermissionsvale == 1) {
    //                 var type = result[i].Type;
    //                 if (type == 'R' || type == 'RW' || type == 'RWD') {
    //                     this.payoutgideshow = true;
    //                 }
    //                 else {
    //                     this.payoutgideshow = false;
    //                 }
    //                 // break
    //             }
    //             if (result[i].UserPermission == 'New') {
    //                 var type = result[i].Type;
    //                 if (type == 'RW' || type == 'RWD') {
    //                     this.newoption = true;
    //                 }
    //                 else {
    //                     this.newoption = false;
    //                 }
    //             }
    //             if (result[i].UserPermission == 'PaymentLedger') {
    //                 var type = result[i].Type;
    //                 if (type == 'R' || type == 'RW' || type == 'RWD') {
    //                     this.newoption = true;
    //                 }
    //                 else {
    //                     this.newoption = false;
    //                 }
    //                 break;
    //             }
    //         }

    //     }

    // });
  }
  GetReserve() {
    this.registerUserService
      .GetReserveFund(this.MerchantKeyId)
      .subscribe((result) => {
        if (result.length > 0) {
          this.ReserveFund = true;
        } else {
          this.ReserveFund = false;
        }
      });
  }

  portalSetup() {
    this.MerchantKeyId =
      this.commonfunction.getUserMerchantData().MerchantKeyId;
    this.resellerno = this.commonfunction.getUserMerchantData().ResellerId;
    this.Usertype = this.commonfunction.getUserMerchantData().UserType;
    this.registerUserService
      .getMerchantServicesAndFees(this.MerchantKeyId, this.resellerno)
      .subscribe((result) => {
        var details = _clone(result);
        if (details.length > 0) {
          this.rows = _clone(result);
          this.rows.forEach((element) => {
            if (
              element.ServiceCode == 'PayOut' &&
              element.Status == 1 &&
              element.FeeCode == 'PO'
            ) {
              this.payoutgideshow = true;
              this.getUserPermissions();
              this.paoutpermissionsvale = 1;
            }
            if (element.ServiceCode == 'PayGSetUp' && element.Status == 1) {
              this.PaygsetUphideshow = true;
            }

            if (element.ServiceCode == 'PayGSetUp' && element.Status == 0) {
              this.PaygsetUphideshow = false;
            } else {
              // this.getUserPermissions();
            }
            if (element.ServiceCode == 'Pos' && element.Status == 1) {
              this.PosSetuUphideshow = true;
            }

            if (
              element.ServiceCode == 'PrepaidCard' &&
              element.Status == 1 &&
              this.Usertype == 'Merchant'
            ) {
              this.prepaidcard = true;
            }
            //   else {
            //     if(element.ServiceCode=="PrepaidCard" && element.Status==0){
            //     this.prepaidcard=false;
            //     }
            //   }
            // if (element.ServiceCode == "PrepaidCard")
            //  {
            //   if(element.ServiceCode == "PrepaidCard" && element.Status==1)
            //   {

            //   }
            //   else{
            //     var prepaidcarddetail = this.router.url.includes('prepaidcards')
            //     if(prepaidcarddetail==true)
            //     {
            //       this.router.navigate(["/home"]);
            //     }

            //   }

            //  }
          });
        } else {
          this.getUserPermissions();
        }
      });
  }
}
